const eventClickUpdateProfileLoyalti = ({
  name,
  no_hp,
  email,
  eventAction,
  eventName,
  eventCategory,
  astrapPoint,
}: {
  name: string;
  no_hp: string;
  email: string;
  eventAction?: string;
  eventName?: string;
  eventCategory?: string;
  astrapPoint?: string;
}) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `${eventName ? eventName : 'success_update_profile'}`,
      eventCategory: `${eventCategory ? eventCategory : 'my account page'}`,
      eventAction: `click on ${eventAction}`,
      nama: `${name}`,
      no_hp: `${no_hp}`,
      email: `${email}`,
      astrapPoint,
    });
  }
};

export default eventClickUpdateProfileLoyalti;
